import http from "../http";

export default (axios, base) => ({
  items: () => http.get(`${base}/items`),
  approve: (data) => http.put(`${base}/approve`, data)
});
